// Identical deck without the email gate
import Deck from "./Deck";

const DeckView = () => {
  return <Deck skipEmailGate />;
};

export default DeckView;
